import { createSlice } from '@reduxjs/toolkit';

const cabinetSlice = createSlice({
  name: 'cabinet',
  initialState: {
    currentStep: 1,
    phoneNumber: '',
    uuid: '',
    deviceInfo: '',
    accounts: [],
    selectedAccountId: '',
    myTariffId: '',
    subscriptionData: {},
    addAccountContent: false,
    additionalNumber: '',
    signInModal: false,
    logoutModal: false,
    deleteNumber: {},
    confirmModal: false,
    initialToken: '',
    isRenewing: false,
    tariffModal: false,
    selectedTariff: {},
    isLoginTerms: false,
    popUpStep: 0,
    accessToken: '',
    popUpAccount: {},
    isTariff: true,
    selectedPackage: {},
    popUpConfirm: false,
    tariffLoading: false,
    isLogged: false,
  },
  reducers: {
    nextStep: (state) => {
      state.currentStep += 1;
    },
    prevStep: (state) => {
      state.currentStep -= 1;
    },
    setPhoneNumber: (state, action) => {
      state.phoneNumber = action.payload;
    },
    setUuId: (state, action) => {
      state.uuid = action.payload;
    },
    setDevice: (state, action) => {
      state.deviceInfo = action.payload;
    },
    setAccounts: (state, action) => {
      state.accounts = action.payload;
    },
    setSelectedAccountId: (state, action) => {
      state.selectedAccountId = action.payload;
    },
    setMyTariffId: (state, action) => {
      state.myTariffId = action.payload;
    },
    setSubscriptionData: (state, action) => {
      state.subscriptionData = action.payload;
    },
    setAddAccountContent: (state, action) => {
      state.addAccountContent = action.payload;
    },
    setAdditionalNumber: (state, action) => {
      state.additionalNumber = action.payload;
    },
    setSignInModal: (state, action) => {
      state.signInModal = action.payload;
    },
    setLogoutModal: (state, action) => {
      state.logoutModal = action.payload;
    },
    setDeleteNumber: (state, action) => {
      state.deleteNumber = action.payload;
    },
    setConfirmModal: (state, action) => {
      state.confirmModal = action.payload;
    },
    setInitialToken: (state, action) => {
      state.initialToken = action.payload;
    },
    setIsRenewing: (state, action) => {
      state.isRenewing = action.payload;
    },
    setTariffModal: (state, action) => {
      state.tariffModal = action.payload;
    },
    setSelectedTariff: (state, action) => {
      state.selectedTariff = action.payload;
    },
    setIsLoginTerms: (state, action) => {
      state.isLoginTerms = action.payload;
    },
    setPopUpStep: (state, action) => {
      state.popUpStep = action.payload;
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    setPopupAccount: (state, action) => {
      state.popUpAccount = action.payload;
    },
    setIsPackageOrTariff: (state, action) => {
      state.isPackageOrTariff = action.payload;
    },
    setSelectedPackage: (state, action) => {
      state.selectedPackage = action.payload;
    },
    setPopUpConfirm: (state, action) => {
      state.popUpConfirm = action.payload;
    },
    setTariffLoading: (state, action) => {
      state.tariffLoading = action.payload;
    },
    setIsLogged: (state, action) => {
      state.isLogged = action.payload;
    },
  },
});

export const { actions } = cabinetSlice;
export default cabinetSlice.reducer;
